import React from "react";
import { CheckCircle, AlertCircle, AlertTriangle, X } from "lucide-react";

const Toast = ({ message, type = "success", onClose }) => {
  const config = {
    success: {
      bgColor: "bg-green-50",
      borderColor: "border-green-500",
      textColor: "text-green-800",
      icon: CheckCircle,
      iconColor: "text-green-500",
    },
    error: {
      bgColor: "bg-red-50",
      borderColor: "border-red-500",
      textColor: "text-red-800",
      icon: AlertCircle,
      iconColor: "text-red-500",
    },
    warning: {
      bgColor: "bg-orange-50",
      borderColor: "border-orange-500",
      textColor: "text-orange-800",
      icon: AlertTriangle,
      iconColor: "text-orange-500",
    },
    info: {
      bgColor: "bg-blue-50",
      borderColor: "border-blue-500",
      textColor: "text-blue-800",
      icon: AlertCircle,
      iconColor: "text-blue-500",
    },
  };

  const {
    bgColor,
    borderColor,
    textColor,
    icon: Icon,
    iconColor,
  } = config[type] || config.success;

  return (
    <div className="fixed top-4 right-4 z-50 animate-slide-in-right">
      <div
        className={`${bgColor} ${borderColor} border-l-4 rounded-lg shadow-lg p-4 max-w-md flex items-start space-x-3`}
      >
        <Icon className={`${iconColor} flex-shrink-0 mt-0.5`} size={20} />
        <p className={`${textColor} text-sm font-medium flex-1`}>{message}</p>
        {onClose && (
          <button
            onClick={onClose}
            className={`${textColor} hover:opacity-70 flex-shrink-0`}
          >
            <X size={18} />
          </button>
        )}
      </div>
    </div>
  );
};

export default Toast;
